export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-blue-400 mb-4">AvtechAI</h3>
            <p className="text-gray-300 mb-4">
              Empowering businesses with innovative AI solutions and cloud
              technologies. We transform ideas into intelligent, scalable
              applications.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.credly.com/users/bala-subramanyam-vyamajala-venkata/badges"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-blue-400 transition-colors"
              >
                AWS Certifications
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="/about"
                  className="text-gray-300 hover:text-blue-400 transition-colors"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/products"
                  className="text-gray-300 hover:text-blue-400 transition-colors"
                >
                  Products
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-gray-300 hover:text-blue-400 transition-colors"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-gray-300 hover:text-blue-400 transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-gray-300">
              <p>avtechaillc@gmail.com</p>
              <p>Atlanta, GA</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>
            &copy; {new Date().getFullYear()} AvtechAI LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
